module.exports = __webpack_public_path__ + "static/img/service-icon.d886544c.png";